import React, { useState } from 'react';
import { Dropdown, Space, Modal, theme  } from 'antd';
import Button from "components/button";
import IndexModal from "components/modal";
import {
  DownOutlined, EyeOutlined, EditOutlined, DeleteOutlined, TagOutlined
} from '@ant-design/icons';

const { useToken } = theme;

const CrudOption = (props) => {
  	const { baseRoute, recordId, queryParams, deleteHandler, excludeHandler, forFinalPayHandler, additionalMenu, 
  		allowView=true, allowEdit=true, allowDelete=true, allowExclude=false, allowForFinalPay=false, viewMode = "page", 
		viewHandler, title, closeHandler, editMode = "page", editHandler, detailMode = "page", detailHandler, allowDetail=false,
		modalContainerClass, modalWidth=850,
  		} = props;
  		
  	const { token } = useToken();
  	const [open, setOpen] = useState(false);
	const [actionType, setActionType] = useState('delete');
	const [confirmTitle, setConfirmTitle] = useState('Confirm Delete');
	const [confirmMessage, setconfirmMessage] = useState('Are you sure you want to delete this record?');
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentId, setCurrentId] = useState(null);
  	const menuOptions = [
		{
			key: 'view',
			label: 
				viewMode === "modal" ? (
				<span onClick={() => {
					setCurrentId(recordId);
					setIsModalOpen(true);
				}}
				className="cursor-pointer">
					View
				</span>
				) : (
				<a
					href={`${baseRoute}/${recordId}/view${queryParams ? '?' + queryParams : ''}`}
				>
					View
				</a>
				),
			icon: <EyeOutlined />,
			available: allowView ? 1 : 0,
		},
		{
			key: 'edit',
			label: 
				editMode === "modal" ? (
				<span onClick={() => {
					setCurrentId(recordId);
					setIsModalOpen(true);
				}}
				className="cursor-pointer">
					Edit
				</span>
				) : (
				<a 
					href={`${baseRoute}/${recordId}/edit${queryParams ? '?'+queryParams : ''}`}
				>
					Edit
				</a>
				),
			icon: <EditOutlined />,
			available: allowEdit ? 1 : 0,
		},
		{
			key: 'exclude',
			label: (
				<div onClick={(e) => {e.preventDefault();openConfirmation('exclude')}}>
					Exclude
				</div>
			),
			icon: <TagOutlined />,
			available: allowExclude ? 1 : 0,
		},
		{
			key: 'forfinalpay',
			label: (
				<div onClick={(e) => {e.preventDefault();openConfirmation('forfinalpay')}}>
					For Final Pay
				</div>
			),
			icon: <TagOutlined />,
			available: allowForFinalPay ? 1 : 0,
		},	
		{
			key: 'delete',
			label: (
				<div className="text-red-700" onClick={(e) => {e.preventDefault();openConfirmation('delete')}}>
					Delete
				</div>
			),
			icon: <DeleteOutlined className="text-red-700"/>,
			available: allowDelete ? 1 : 0,
		},
		{
			key: 'detail',
			label: 
				detailMode === "modal" ? (
				<span onClick={() => {
					setCurrentId(recordId);
					setIsModalOpen(true);
				}}
				className="cursor-pointer">
					View
				</span>
				) : (
				<a
					href={`${baseRoute}/${recordId}/view${queryParams ? '?' + queryParams : ''}`}
				>
					View
				</a>
				),
			icon: <EyeOutlined />,
			available: allowDetail ? 1 : 0,
		},	  
	];
	
	const allMenuOptions = additionalMenu ? menuOptions.concat(additionalMenu) : menuOptions;
	const items = allMenuOptions.filter(item => item.available === 1);	
	
	const contentStyle = {
	    backgroundColor: token.colorBgElevated,
	    borderRadius: token.borderRadiusLG,
	    boxShadow: token.boxShadowSecondary,
  	};
	const menuStyle = {
	    boxShadow: 'none',
  	};

	const openConfirmation = (type) => {		
		setActionType(type);
		if(type === 'forfinalpay'){
			setConfirmTitle('Confirm For Final Pay');
			setconfirmMessage('Are you sure you want to set this record to for final pay type?');
		}else if(type === 'exclude'){
			setConfirmTitle('Confirm Exclude');
			setconfirmMessage('Are you sure you want to set this record to exclude type?');
		}else{
			setConfirmTitle('Confirm Delete');
			setconfirmMessage('Are you sure you want to delete this record?');
		}
		
		setOpen(true);
	}

	const onClickConfirmation = () => {
		if(actionType === 'exclude'){
			excludeHandler({mode: 'reload', recordId})
		}else if(actionType === 'forfinalpay'){
			forFinalPayHandler({mode: 'reload', recordId})
		}else{
			deleteHandler({mode: 'reload', recordId})
		}
	}

	const onClosePopupModal = () => {
		if(closeHandler){ closeHandler(); }
		setIsModalOpen(false);
		
	}
	
  	return (
		  <div>
	    	<Dropdown
	    		menu={{items}}
			  	dropdownRender={(menu) => (
			        <div style={contentStyle}>
						{React.cloneElement(menu, {
							style: menuStyle,
						})}			          
			        </div>
			      )}       		
	    	>
			    <div className="cursor-pointer">
					<Space>
						Action
						<DownOutlined />
					</Space>
			    </div>
		  	</Dropdown>
		  	<Modal
                open={open}
                closeIcon={false}
                centered
				title={<h2 className="popup-modal-title">{confirmTitle}</h2>}
                okText="Confirm"
                cancelText="Cancel"
                footer={(_) => (
                    <>
                        <Button className="me-4 btn-primary" 
                            onClick={(e) => {setOpen(false)}}
                        >
                            Cancel
                        </Button>
                        <Button className="btn-primary"
                            onClick={(e) => {setOpen(false); onClickConfirmation()}}
                        >
                            Confirm
                        </Button>
                    </>
                )}
            >
				<div className='content-wrapper'>{confirmMessage}</div>
            </Modal>

			{viewMode === "modal" && (
				<IndexModal
					open={isModalOpen}
					onClose={onClosePopupModal}
					title={title}
					width={modalWidth}
					modalContainerClass={modalContainerClass}
				>
					{viewHandler ? viewHandler(currentId, onClosePopupModal) : null}
				</IndexModal>
			)}	

			{editMode === "modal" && (
				<IndexModal
					open={isModalOpen}
					onClose={onClosePopupModal}
					title={title}
				>
					{editHandler ? editHandler(currentId, onClosePopupModal) : null}
				</IndexModal>
			)}

			{detailMode === "modal" && (
				<IndexModal
					open={isModalOpen}
					onClose={onClosePopupModal}
					useCustomClass={true}
					maxContentHeight="90vh"
					width="sm:max-w-lg max-w-2xl"
				>
					{detailHandler ? detailHandler(currentId, onClosePopupModal) : null}
				</IndexModal>
			)}
	  	</div>
  );
}

export default CrudOption;
